import { buildClassName, mix } from "@chorda/core";
export const Title = (props) => {
    return mix({
        css: 'title',
        reactions: {
            text: (v) => ({ text: v })
        }
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        injections: {
            text: props.text$ // || ((ctx: any) => observable(props.text || ctx.text))
        },
        css: buildClassName(props.css, props.size),
        text: props.text
    });
};
export const Subtitle = (props) => {
    return mix({
        css: 'subtitle',
        reactions: {
            text: (v) => ({ text: v })
        }
    }, {
        injections: {
            text: props.text$ // (ctx: any) => observable(props.text || ctx.text)
        },
        css: buildClassName(props.css, props.size),
        text: props.text
    });
};
